import { z } from 'zod';

import { Ulid } from './common.js';

export const Reminder = z.object({
  id: Ulid,
  leadId: Ulid,
  userId: Ulid,
  dueAt: z.string().datetime(),
  message: z.string().max(2000).nullable(),
  completedAt: z.string().datetime().nullable(),
  notifiedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type Reminder = z.infer<typeof Reminder>;

export const ReminderCreate = z.object({
  dueAt: z.string().datetime(),
  message: z.string().max(2000).optional(),
  /** Defaults to the calling user. MASTER/manager can target other members. */
  userId: Ulid.optional(),
});
export type ReminderCreate = z.infer<typeof ReminderCreate>;
